module.exports = __webpack_public_path__ + "static/media/mockMenus.1de27929.webp";